import { request } from "./request";

export function getSchedule(chairId) {
  const id = encodeURIComponent(String(chairId));
  return request(`/chair/getSchedule?chairId=${id}`, {
    method: "GET",
  });
}

export function saveSchedule(data) {
  const selectedHours = Array.isArray(data.restSlotHours)
    ? data.restSlotHours
    : [];
  return request("/chair/saveSchedule", {
    method: "POST",
    body: {
      chairId: String(data.chairId),
      scheduleDate: String(data.scheduleDate),
      slots: selectedHours.map((hour) => ({
        slotHour: Number(hour),
      })),
    },
  });
}
